import { HtmlInAppMessageDOMManager } from "./HtmlInAppMessageDOMManager"
import ObjectUtil from "../../../../../core/internal/util/ObjectUtil"
import { InAppMessageBridgeInstaller } from "../../html/InAppMessageBridgeInstaller"
import { HtmlInAppMessageDOMStyle } from "./HtmlInAppMessageDOMStyle"
import { RunnableCallback } from "../../../../../core/internal/util/Callback"
import { InAppMessageBridge } from "../../html/InAppMessageBridge"

export class HtmlInAppMessageRenderer {
  constructor(private readonly domManager: HtmlInAppMessageDOMManager) {}

  render(htmlContent: string, bridge: InAppMessageBridge, onReady: RunnableCallback<void>): void {
    const [wrapper, iframe] = this.domManager.createElement()
    this.setStyle(iframe, HtmlInAppMessageDOMStyle.beforeLoadedIframeStyles())
    this.setStyle(wrapper, HtmlInAppMessageDOMStyle.beforeLoadedWrapperStyles())

    // iframe을 DOM에 붙이기 전에 미리 리스너를 등록한다.
    this.domManager.onLoad(() => {
      const contentWindow = ObjectUtil.requiredNotNullOrUndefined(
        this.domManager.getIframeContentWindow(),
        () => "Failed to render HTML inAppMessage. (HTML inAppMessage's container element is not found.)"
      )

      // iframe이 로드된 후, bridge를 설치한다. 이 시점에 hackleBridgeReady 이벤트가 발행됨.
      InAppMessageBridgeInstaller.install(contentWindow, bridge)
      this.setStyle(iframe, HtmlInAppMessageDOMStyle.afterLoadedIframeStyles())
      this.setStyle(wrapper, HtmlInAppMessageDOMStyle.afterLoadedWrapperStyles())

      // view에게 ready 콜백을 실행하도록 알린다.
      onReady.once()
    })

    // iframe에 html 콘텐츠를 렌더링한다.
    this.renderHtmlString(iframe, htmlContent)

    // iframe을 DOM에 붙인다.
    this.domManager.attachToDOM()
  }

  destroy(): void {
    this.domManager.removeElement()
  }

  private setStyle(element: HTMLElement, styles: Record<string, string>): void {
    Object.assign(element.style, styles)
  }

  private renderHtmlString(iframe: HTMLIFrameElement, htmlContent: string): void {
    iframe.srcdoc = htmlContent
  }
}
